import { motion } from 'framer-motion';

const EASE = [0.16, 1, 0.3, 1];

export const SplitLines = ({ lines, start, inView = false, delay = 0, className = '', lineClassName = '' }) => {
  const containerProps = inView
    ? { initial: 'hidden', whileInView: 'visible', viewport: { once: true, margin: '-10% 0px' } }
    : { initial: 'hidden', animate: start ? 'visible' : 'hidden' };

  return (
    <motion.span className={`block ${className}`} {...containerProps}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            variants={{ hidden: { y: '115%' }, visible: { y: '0%' } }}
            transition={{ duration: 1, delay: delay + i * 0.13, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};
